import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import { io } from "socket.io-client";
import { wati_DOMAIN } from "../constants";

const WatiSocketContext = createContext();

export const useWatiSocket = () => {
  const context = useContext(WatiSocketContext);
  if (!context) {
    throw new Error('useWatiSocket must be used within a WatiSocketProvider');
  }
  return context;
};

export const WatiSocketProvider = ({ children }) => {
  const [watiChatUpdates, setWatiChatUpdates] = useState([]);
  const [queryUpdates, setQueryUpdates] = useState([]);
  const [isWatiConnected, setIsWatiConnected] = useState(false);
  const socketRef = useRef(null);

  useEffect(() => {
    const socket = io(wati_DOMAIN, {
      transports: ["websocket"],
      reconnection: true,
      reconnectionDelay: 2000,
    });

    socketRef.current = socket;

    socket.on("connect", () => {
      console.log(`Wati socket connected!!`);
      setIsWatiConnected(true);
    });

    socket.on("disconnect", () => {
      console.log(`Wati socket disconnected!!`);
      setIsWatiConnected(false);
    });

    socket.on("connect_error", () => {
      console.log(`Wati socket connection error!!`);
      setIsWatiConnected(false);
    });

    socket.on("chatUpdate", (data) => {
      setWatiChatUpdates((prev) => [...prev, data]);
    });

    socket.on("queryUpdate", (data) => {
      setQueryUpdates((prev) => [...prev, data]);
    });



    return () => {
      socket.disconnect();
    };
  }, []);

  const reconnect = () => {
    socketRef.current?.connect();
  };

  return (
    <WatiSocketContext.Provider value={{ watiChatUpdates, setWatiChatUpdates, queryUpdates, isWatiConnected, reconnect }}>
      {children}
    </WatiSocketContext.Provider>
  );
};
